import {slideDown, slideUp } from "./helpers";

export default class SiteFooter {
	constructor() {
		this.el                  = document.querySelector( '.site-footer' )
		this.mainMenuParentItems = this.el.querySelectorAll( '.site-footer__menu .menu .menu-item-has-children' )
		this.mainMenuParentItems.forEach(
			parentItem => {
            parentItem.querySelector( ':scope > a' ).addEventListener(
					'click',
					(e) => {
                    if ( ! window.matchMedia( '(min-width: 768px)' ).matches) {
                        e.preventDefault();
                        if (parentItem.classList.toggle( 'is-open' )) {
                            slideDown( parentItem.querySelector( ':scope > .sub-menu' ) )
                        } else {
                            slideUp( parentItem.querySelector( ':scope > .sub-menu' ) )
                        }
                    }
					}
				)
			}
		)
	}
}
